// utils/constants.js

const BINANCE = 'binance'
const OKX = 'okx'
const CRYPTO = 'CRYPTO'
const A = 'A'
const NEWONLINE = 'NEWONLINE'
const CALCULATOR = 'CALCULATOR'

module.exports = {
    BINANCE,
    OKX,
    CRYPTO,
    A,
    NEWONLINE,
    CALCULATOR,
}